<template>

    <div class="m-5">

        <div class="mb-1 text-gray-600">Ankerpunt</div>

        <small class="block mb-3 text-gray-500 text-muted">Vul hier een anchor in. Dit betreft het #
            deel achter een url. Hiermee kan je linken naar dit blok.</small>

        <input type="text"
               class="focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm border border-gray-300 border-solid duration-150 ease-in-out mt-1 px-3 py-2 rounded-md shadow-sm transition w-full"
               @input="$set(options, 'anchor', $event.target.value)"
               placeholder="categorie"
               :value="options.anchor"/>

    </div>

</template>

<script>

export default {

    props: {
        options: Object,
    },

}

</script>
